import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

const CategoriesTable = ({ handleCategoryPageChange, onEdit, onDelete, handlePageChange  }) => {
  const { categories, currentCategoryPage, totalCategoryPages } = useSelector((state) => state.admin_videos);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCategories, setFilteredCategories] = useState(categories);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (activeDropdown === id) {
      setActiveDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setActiveDropdown(id);
    }
  };

  useEffect(() => {
    const filtered = categories.filter(category =>
      category.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredCategories(filtered);
  }, [categories, searchTerm]);

  const handleDelete = (id) => {
    confirmAlert({
      title: 'Confirm Deletion',
      message: 'Are you sure you want to delete this category?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => onDelete(id)
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleScroll = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex text-center printarea">
        <thead>
          <tr>
            <th><div className="text-start">Category Name</div></th>
            <th className="noprint">Manage</th>
          </tr>
        </thead>
        <tbody>
          {
              filteredCategories.map((category) => (
              <tr key={category.id}>
                <td><div className="text-start">{category.title}</div></td>
                <td className="noprint">
                <div className="text-center position-relative">
                  <button
                    type="button"
                    className="bg-transparent border-0 p-0 btn-vert-dots dropdown-toggle"
                    aria-expanded={activeDropdown === category.id}
                    onClick={(e) => toggleDropdown(category.id, e)}
                  >
                    <img src={optionsIcon} alt="Options" />
                  </button>
                  {activeDropdown === category.id && (
                    <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                       <li>
                          <a className="dropdown-item" onClick={() => onEdit(category)}>
                            <img src={editIcon} alt="Edit" /> Edit
                          </a>
                        </li>
                        
                         {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                        <li>
                          <a className="dropdown-item" onClick={() => handleDelete(category.id)}>
                            <img src={deleteIcon} alt="Delete" /> Delete
                          </a>
                        </li>
                        )}
                        
                    </ul>
                  )}
                  </div>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
      </div>
      <Pagination
        currentPage={currentCategoryPage}
        totalPages={totalCategoryPages}
        onPageChange={handleCategoryPageChange}
      />
      </>
  );
};

export default CategoriesTable;